var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/select-dropdown/select-dropdown.html';
var html = "<div class=select-main-div> <div class=form-group> <label for=select-text>{{$ctrl.labelText}}</label> <div class=select-wrapper> <select class=form-control id=year ng-model=$ctrl.selectedId ng-change=$ctrl._onChange($ctrl.selectedId) required> <option value=\"\" ng-disabled=$ctrl.isDisabled selected=$ctrl.selectedId> Select an Option </option> <option ng-repeat=\"item in $ctrl._list track by item.id\" ng-value=item.id ng-selected=item.selected> {{item.name}} </option> </select> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/select-dropdown/select-dropdown.html
// module id = 927
// module chunks = 0